import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
// import BuoySubscribe from './../BuoySubscribe';
import JPEmailBox from './JPEmailBox';
import NAJoinUsLead from './NAJoinUsLead';
import JPBannerCTA from './JPBannerCTA';
import { BannerImgAll } from './imgConfig';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import { useLang } from '@/i18n';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { IPageStatus } from '@/components/MembersDay/type';
import { EU_SITES, euEmailSource, currentEmailSource, NA_SITES } from '@/constants/membersday';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { getPrivacyPolicy } from '@/utils/common';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.membersbanner');
    const { pageStatus, isLogin } = useMembersStore();
    const { locale } = getLocal();
    const { t: _t } = useLang(`membersday.${pageStatus}.membersbanner`);
    const BannerImgA = BannerImgAll[locale] || BannerImgAll['us'];

    // 邮箱订阅
    let sources = currentEmailSource;
    if (EU_SITES.includes(locale)) {
        if (pageStatus === IPageStatus.TEASER || pageStatus === IPageStatus.ACTIVITY) {
            sources = euEmailSource.teaser;
        }
        if (pageStatus === IPageStatus.RETURN) {
            sources = euEmailSource.return;
        }
    }

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    return (
        <div className={`${styled.Banner} banner`} id="teaser-first-banner">
            {pageStatus === IPageStatus.TEASER && (
                <>
                    <EditorImg
                        pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710666899720/KVjpg.jpg'}
                        h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667010339/MO-KVjpg.jpg"
                        alt={''}
                    />
                    <div className="text">
                        <div className="text-in">
                            <h1 className="title">{t('title')}</h1>
                            <p className="subtitle">{t('subtitle')}</p>
                            <p className="desc">{t('desc')}</p>
                            {locale === 'jp' && <JPEmailBox />}
                        </div>
                    </div>
                </>
            )}
            {pageStatus !== IPageStatus.TEASER && pageStatus !== IPageStatus.END && (
                <>
                    <EditorImg pc={BannerImgA.pc} h5={BannerImgA.h5} alt={''} />
                    <div className="text">
                        <div className="text-in">
                            <p className="tips">{_t('tips_actv')}</p>
                            <h1 className="title">{_t('title_actv')}</h1>
                            <p className="subtitle">{_t('subtitle_actv')}</p>
                            <p className="subtitle2">{_t('desc_actv')}</p>
                            <div className="email-box">
                                <Emarsys
                                    source={sources}
                                    submitText={t('btnText')}
                                    placeholder={t('placeholder')}
                                    successCallback={successCallBack}
                                    errorCallback={errorCallback}
                                />
                                {EU_SITES.includes(locale) && (
                                    <p className="protocol">
                                        {t.rich('protocol', {
                                            line1: (text: string) => (
                                                <a className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                                                    {text}
                                                </a>
                                            ),
                                            line2: (text: string) => (
                                                <a
                                                    className="link"
                                                    href={`https://${locale}.ecoflow.com/policies/terms-of-service`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {text}
                                                </a>
                                            ),
                                        })}
                                    </p>
                                )}
                            </div>
                            {NA_SITES.includes(locale) && <NAJoinUsLead />}
                            {locale === 'jp' && !isLogin && <JPBannerCTA title={t('title')} />}
                        </div>
                    </div>
                </>
            )}
            {pageStatus === IPageStatus.END && (
                <>
                    <EditorImg
                        pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710666899720/KVjpg.jpg'}
                        h5="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667010339/MO-KVjpg.jpg"
                        alt={''}
                    />
                    <div className="text end">
                        <div className="text-in">
                            {locale === 'kr' && <p className="subtitle3">{_t('title3')}</p>}
                            <h1 className="title">{_t('title1')}</h1>
                            <p className="subtitle">{_t('title2')}</p>
                            {locale !== 'kr' && <p className="subtitle3">{_t('title3')}</p>}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Banner;
